import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { StatiVideoperiziaComponent } from 'src/app/admin/stati-videoperizia/stati-videoperizia.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => StatoVideoperiziaPickerComponent) },
  ],
  selector: 'stato-videoperizia-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class StatoVideoperiziaPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(StatiVideoperiziaComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
